export default __webpack_public_path__ + "static/media/blog1.93eb35f7.png";